<template>
  <div class="agreement_page">
    <div class="agreement_title">{{info.title}}</div>
    <div class="agreement_content" v-html="info.content"></div>
    <!-- <h1>凌志范儿车主认证个人信息保护声明</h1>
    <div class="content">
      <p>凌志范儿车主认证是凌志范儿推出的车主认证服务，有车用户可以通过车主认证服务体现自己的车主身份。车主认证遵循凌志范儿保护用户个人信息的基本原则，不会通过任何渠道泄露您的个人信息，请您放心上传相关认证资料。</p>
      <p>凌志范儿将按照本声明及《隐私协议》（链接地址：<a href="https://m.motortime.com/lexus-falv">https://m.motortime.com/lexus-falv</a>）的规定收集、使用、储存您的个人信息。本协议对个人信息保护规定的内容与上述《隐私协议》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，以《隐私协议》的内容为准。</p>
      <p style="font-weight: bold;">一、个人信息的收集</p>
      <p>1、我们收集您的个人信息的最终目的是为了向您提供更好的产品、服务，优化并丰富您的用户体验，这些个人信息是能够单独或者与其他信息结合识别您的个人身份的信息，包括：</p>
      <p>①行驶证页面照片（其中包含：姓名、车牌号、住址、车辆识别代号等信息）</p>
      <p>②海外车主上传爱车照片要求为彩色、完整的原件（扫描或照片)，能够清晰辨识图案和文字内容</p>
      <p>③在您上载到本平台的内容中包含的任何个人信息</p>
      <p>2、以上个人信息均是您自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用我们提供的产品、服务，或者可能对您使用产品或服务造成一定的影响。</p>
      <p>3、对于不满 18 岁的用户，须在其法定监护人已经阅读本声明并且许可的情况下，通过网站提交个人信息。</p>
      <p style="font-weight: bold;">二、个人信息的使用</p>
      <p>您同意，凌志范儿可以通过以下方式对个人信息进行使用（包含对于个人信息的存储和处理）：</p>
      <p>1、我们为满足您的需求，可以通过您提供的信息与您联系；</p>
      <p>2、我们可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息。</p>
      <p>以上，仅在凌志范儿内部使用。</p>
      <p>您同意免除上述个人信息的接收和/或使用方在按照本法律声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。</p>
      <p style="font-weight: bold;">三、更正或投诉</p>
      <p>如果您需要查询、修改或更正您的个人信息，或对个人信息保护问题有任何疑问或投诉，可以发送邮件进行反馈，联系邮箱：kefu@motortime.com</p>
    </div> -->
  </div>
</template>

<script>
  import common from '../../../api/common';
  import content from '../../../api/content';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        info:''
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      let source = this.$store.state.param.source
      if(source == 3) {
        this.name = '汽车时间'
        this.$appService.isShowReturn({state: true})
      } else if(source == 6) {
        this.name = '凌志范儿'
        this.$appService.isShowReturn({state: true})
      }else if(source == 8) {
        this.name = '凌志范儿'
        this.$appService.isShowReturn({state: true})
      }
      var params={
        event_code: '凌志范儿车主认证个人信息保护声明',
        event_id:'',
        title: '',
        value: '',
        path: '/Lexus/Page/Carstate.vue',
        user_id: this.user_id ? this.user_id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
      this.getAgreement(12)
    },
    methods: {
      getAgreement(id){
        content.getAgreement({id:id}).then(res => {
          this.info=res.data.data
        })
      },
    }
  };
</script>

<style lang="scss">
  .agreement_page {
    padding: 10px;
  }
</style>
